import { createApp } from 'vue';
import Axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import './style/index.css';

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
document.title = 'FileDrop';

store.dispatch('loadUser');

createApp(App).use(store).use(router).mount('#app');
